module.exports = __webpack_public_path__ + "a5aa77e378c60b78a57638af9984c7ed.webp";